import React from "react"
import LoggingPayments from '../../../components/organisms/admin/logging/LoggingPayments'
const LoggingPaymentsPage = () => {
    return <LoggingPayments />


}
export default LoggingPaymentsPage